import LoadingPage from "components/LoadingPage";
import { lazy, Suspense } from "react";

const LandingPagesList = lazy(() => import("pages/LandingPagesList"));
const LP1 = lazy(() => import("pages/LandingPagesList/DemosLandingPage/1"));
const LP3 = lazy(() => import("pages/LandingPagesList/DemosLandingPage/2"));
const LP1Page = lazy(() => import("pages/LandingPagesList/LP1"));
const LP2Page = lazy(() => import("pages/LandingPagesList/LP2"));
const LP3Page = lazy(() => import("pages/LandingPagesList/LP3"));
const LP4Page = lazy(() => import("pages/LandingPagesList/LP4"));
const LP5Page = lazy(() => import("pages/LandingPagesList/LP5"));
const LP6Page = lazy(() => import("pages/LandingPagesList/LP6"));
const LP7Page = lazy(() => import("pages/LandingPagesList/LP7"));
const LP8Page = lazy(() => import("pages/LandingPagesList/LP8"));
const LP9Page = lazy(() => import("pages/LandingPagesList/LP9"));
const LP10Page = lazy(() => import("pages/LandingPagesList/LP10"));
const LP11Page = lazy(() => import("pages/LandingPagesList/LP11"));
const LP12Page = lazy(() => import("pages/LandingPagesList/LP12"));
const LP13Page = lazy(() => import("pages/LandingPagesList/LP13"));
const LP14Page = lazy(() => import("pages/LandingPagesList/LP14"));
const LP15Page = lazy(() => import("pages/LandingPagesList/LP15"));

const useRoutersLandingPage = () => {
  return [
    {
      path: "/landing-page",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LandingPagesList />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/1",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP1Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/demo/1",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP1 />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/2",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP2Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/3",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP3Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/demo/3",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP3 />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/4",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP4Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/5",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP5Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/6",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP6Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/7",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP7Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/8",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP8Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/9",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP9Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/10",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP10Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/11",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP11Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/12",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP12Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/13",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP13Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/14",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP14Page />
        </Suspense>
      ),
    },
    {
      path: "/landing-page/15",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LP15Page />
        </Suspense>
      ),
    },
  ];
};

export default useRoutersLandingPage;
